import _ from 'lodash';
class TableGridRemoveCellController {

  constructor() {
    this.name = 'tableGridRemoveCell';
  }

  remove(column, cellValue, metaData) {
    let values = metaData[column.objectToRemoveFrom].dataSet[column.arrayToRemoveFrom];
    
    if (values.length !== 0) {
      _.remove(values, (value) => {
        return value.id === cellValue;
      });
    }
  }
}
export
default TableGridRemoveCellController;


// WEBPACK FOOTER //
// ./app/components/tableGridRemoveCell/tableGridRemoveCell.controller.js